import { defineComponent as _defineComponent } from 'vue'
import ContentBox from "@/components/content-box/index.vue";
import Empty from "@/components/empty/index.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return { __sfc: true,ContentBox, Empty }
}

})